var exports = {
  "kL": "Tabs.module__container___c0N5ck",
  "Mf": "Tabs.module__tab___c0N5ck",
  "wH": "Tabs.module__selected___c0N5ck",
};

module.exports = exports;
